
/**
 * @summary Enum which represents the Vuex modules avaliable.
 */
export enum Modules {
	Areas = "areas",
    AreaEventHistory = "areaEventHistory",
    CustomFields = "customFields",
    Devices = "devices",
    EventQueue = "eventqueue",
    GenericTable = "GenericTable",
	Reports = "reports",
    SiteMonitor = "siteMonitor",
	SiteMonitorCameras = "siteMonitorCameras",
	Tours = "tours",
    Responses = "responses",
    InvolvedParties = "involvedParties",
    RulesEngine = "rulesEngine",
	Subscription = "subscription",
	Sessions = "sessions"
}
